var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-form",
                {
                  staticClass: "my-2"
                },
                [
                  _c(
                    "v-row",
                    [
                      _vm._t("before-password"),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "4"
                          }
                        },
                        [
                          _c("compact-password", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:8",
                                expression: "'required|min:8'"
                              }
                            ],
                            attrs: {
                              outlined: "",
                              "cpanel-app": "passwd",
                              "show-strength": "",
                              "with-generator": "",
                              charset:
                                "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789_",
                              autocomplete: "new-password",
                              label: "New Password",
                              "data-vv-name": "password",
                              "data-vv-as": "Password",
                              "error-messages": _vm.errors.collect("password")
                            },
                            model: {
                              value: _vm.password,
                              callback: function callback($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mt-2 ml-0",
                      attrs: {
                        loading: _vm.loading
                      },
                      on: {
                        click: _vm.changePassword
                      }
                    },
                    [_vm._v(" Change Password ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }